export default {
  title: 'Potwierdzenie hasła',
  type: 'object',
  properties: {
    password: {
      type: 'string',
      title: 'Hasło',
      fieldRequired: true,
      minLength: 8,
      validFunc: 'new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*._()?])").test($value)',
      validationMessages: {
        required: 'Hasło jest wymagane',
        minLength: 'Minimalna długość hasła wynosi 8',
        validFunc: 'Hasło powinno zawierać przynajmniej jedną dużą literę, jedną małą literę, cyfrę oraz znak specjalny'
      }
    },
    repeat: {
      type: 'string',
      title: 'Powtórz hasło',
      fieldRequired: true,
      validFunc: '$value && this.password ? $value === this.password : true',
      validationMessages: {
        required: 'Powtórzenie hasła jest wymagane',
        validFunc: 'Oba hasła muszą być takie same'
      }
    }
  }
};
